
import React from 'react';
import './MentorProfile.css';

const MentorProfile = () => {
  return (
  
      <>
        <h1 className="mentor-page-title">Know your Mentor</h1>
        <section className="mentor-grid-section">
        <div className="mentor-grid-left">
          <img
            src="/images/chai.png"
            alt="Profile"
            className="mentor-cover-photo"
          />
          
        </div>
        <div className="mentor-grid-gap" />
        <div className="mentor-grid-right">
          <div className="mentor-dashboard-tiles">
            {/* Tile 1: Experience */}
            <div className="mentor-tile mentor-tile-exp">
              <div className="mentor-tile-title mentor-tile-title-large">2 Decades of Experience</div>
              <div className="mentor-tile-icons">
                <img src="/images/icons/microsoft.png" alt="Microsoft" title="Microsoft" />
                <img src="/images/icons/azure.png" alt="Azure" title="Azure" />
                <img src="/images/icons/cloud.png" alt="Cloud" title="Cloud" />
                <img src="/images/icons/web.png" alt="Web" title="Web Development" />
                <img src="/images/icons/mobile.png" alt="Mobile" title="Mobile Apps" />
                <img src="/images/icons/desktop.png" alt="Desktop" title="Desktop Apps" />
              </div>
              <div className="mentor-tile-desc">Application Architect and Development, Mentoring, Digital Transformation</div>
            </div>
            {/* Tile 2: Roles Played */}
            <div className="mentor-tile mentor-tile-roles">
              <div className="mentor-tile-title mentor-tile-title-large">Multiple Roles</div>
              <div className="mentor-tile-role-icons">
                <div className="mentor-role-item">
                  <img src="/images/icons/developer.png" alt="Developer" title="Developer" />
                  <span>Developer</span>
                </div>
                <div className="mentor-role-item">
                  <img src="/images/icons/presales.png" alt="Pre Sales" title="Pre Sales Architect" />
                  <span>Pre Sales Architect</span>
                </div>
                <div className="mentor-role-item">
                  <img src="/images/icons/solution-architect.png" alt="Solution Architect" title="Solution Architect" />
                  <span>Solution Architect</span>
                </div>
                <div className="mentor-role-item">
                  <img src="/images/icons/enterprise-architect.png" alt="Enterprise Architect" title="Enterprise Architect" />
                  <span>Enterprise Architect</span>
                </div>
                <div className="mentor-role-item">
                  <img src="/images/icons/tutor.png" alt="Tutor" title="Tutor" />
                  <span>Tutor</span>
                </div>
              </div>
            </div>
            {/* Tile 3: Social Links */}
            <div className="mentor-tile mentor-tile-social">
              <div className="mentor-tile-title">Connect</div>
              <div className="mentor-tile-social-icons">
                <a href="https://linkedin.com/in/chaitanyarao" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                  <img src="/images/icons/linkedin.png" alt="LinkedIn" />
                </a>
                <a href="https://x.com/chaitanyarao" target="_blank" rel="noopener noreferrer" aria-label="X">
                  <img src="/images/icons/x.png" alt="X" />
                </a>
                <a href="https://meetup.com/members/chaitanyarao" target="_blank" rel="noopener noreferrer" aria-label="MeetUp">
                  <img src="/images/icons/meetup.png" alt="MeetUp" />
                </a>
              </div>
            </div>
          </div>
        </div>
        </section>
      </>
 
  );
}

export default MentorProfile;